<px-o020-subnavigation-text-link
    *ngIf="nav"
    [data]="nav"
    [notSticky]="false"
></px-o020-subnavigation-text-link>
